import { CONSOLE_MODE } from './Seller';
import { WidgetList } from './WidgetList';

export interface UserRoleOrUserPermission {
  roleId: string;
  roleName: string;
  builtInRole: string;
  entityType?: string;
  entityId?: string;
  permissions?: string[];
  inheritedRoleIds?: string[];
}
export interface UserManagementInformation {
  userId: string;
  lastname: string;
  firstname: string;
  credentials: UserRoleOrUserPermission[];
  mail: string;
}

export interface UserAssigned {
  assignedUserId: string;
  isAutoAssigned: boolean;
  assignedByUserId: string;
  dateUtc?: Date;
  assignedUserProfilesNames?: string[];
}

export interface UserPreferences {
  communicationChannel: string;
  language: string;
  lastSelectedStore: string;
  sellerPreferences: {
    sellerId: string;
    consoleMode: CONSOLE_MODE;
  }[];
  selectedWidgets?: { widgetName: WidgetList }[];
}

export interface User {
  firstname: string;
  lastname: string;
  mail: string;
  userId: string;
  preferences: UserPreferences;
  rolePermissions: UserRoleOrUserPermission[];
}

export interface UserSite {
  id: string;
  name?: string;
  type?: string;
  sellerId: string;
  originSSO?: boolean;
}

export interface AllowAllForSellers {
  store: string[];
  repairer: string[];
  supplier: string[];
  warehouse: string[];
}

export interface AssignedSites {
  sites: UserSite[];
  allowAllForSellers: AllowAllForSellers;
}

export const isUserSite = (value: any): value is UserSite => {
  return !!value.name;
};
